// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JoExpectedShipDateHistory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  joDetailId!: number;
  /** DateTimeOffset key */
  modTs!: Date;
  /** DateTime */
  expectedShipDate!: Date;
  /** String(4) */
  modUserInit!: string;
}

